/*
 eギフト用のjsライブラリ
*/
const storefront_api_key = "cf55ed4a7dd0a303bfe7ed284e99443e";
const shopname = "";

/**
* API実行
*/
function apiCall(query) {
 return fetch('https://mrc-dev.myshopify.com/api/2020-10/graphql.json', {   //[shop-name]にurlのショップ名を入力
	 method: 'POST',
	 headers: {
		 'Content-Type': 'application/graphql',
		 'X-Shopify-Storefront-Access-Token': storefront_api_key   //Storefront APIのアクセストークンを入力
	 },
	 "body": query
 }).then(response => response.json());
}

// 曜日
var weeks = ['日','月','火','水','木','金','土'];

// 日付フォーマット
function dateToStr12H(date, format) {
    if (!format) {
        format = 'Y/M/D h:m:s AP';
    }
    var hours = date.getHours();
    var ampm = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12;
    hours = ( hours != 0 ) ? hours : 12; // 0時は12時と表示する
    format = format.replace(/Y/g, date.getFullYear());
    format = format.replace(/M/g, (date.getMonth() + 1));
    format = format.replace(/D/g, date.getDate());
    format = format.replace(/h/g, hours);
    format = format.replace(/W/g, weeks[date.getDay()]);
    format = format.replace(/m/g, date.getMinutes());
    format = format.replace(/s/g, date.getSeconds());
    format = format.replace(/AP/g, ampm);
    return format;
}
// 日付フォーマット 0埋め
function dateToStr12HPad0(date, format) {
    if (!format) {
        format = 'YYYY/MM/DD hh:mm:dd AP'
    }
    var hours = date.getHours();
    var ampm = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12;
    hours = (hours != 0) ? hours : 12; // 0時は12時と表示する
    format = format.replace(/YYYY/g, date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/hh/g, ('0' + hours).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    format = format.replace(/WW/g, weeks[date.getDay()]);
    format = format.replace(/AP/, ampm);
    return format;
}

// emailバリデーション
function validation_email(text) {
  var mailformat = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (!text || text == "") {
    return false;
  }
  if (text.match(mailformat)) {
    return true;
  } else {
    return false;
  }
}

var disableDates = [
 "2021/12/28",
 "2021/12/29",
 "2021/12/30",
 "2021/12/31",
 "2022/01/01",
 "2022/01/02",
 "2022/01/03",
 "2022/01/04",
 "2022/01/05",
 "2022/01/06",
 "2022/01/07",
 "2022/01/10"
];

/**
* 読み込み時の初期化の処理
*/
function init() {

  // 読み込み時は非表示にする
  $('.egift-delivery').hide();

  $( "#datepicker" ).on("load change", function(){
    $(".ui-state-active").removeClass("ui-state-active");
    console.log("reset active")
  });

  $("[name='fix-date']").click(function () {
    const fixDateValue = $(this).val();
    if (fixDateValue === "none-fix-date") {
      $('.egift-delivery').hide();
      //$("#must-fix-date").hide();
      // 設定リセット
      $(".uiDeliveryDateVal,.uiDeliveryDayVal,.uiDeliveryTimeVal").removeAttr("value");
      $(".ui-state-active").removeClass("ui-state-active");
      //$("select.deliveryTime").children().not(":first").remove();
      //$('[name="checkout"]').removeClass("disable");
    } else if (fixDateValue === "fix-date") {
      //$('[name="checkout"]').addClass("disable");
      $('.egift-delivery').show();
    }
  });

  let mindt = new Date();
  mindt.setDate(mindt.getDate() + 7);
  $("#delivery_date").val(dateToStr12HPad0(mindt, "YYYY/MM/DD"));
  let maxdt = new Date();
  maxdt.setDate(maxdt.getDate() + 21);

  let dateFormat = "yy/mm/dd";

  $( "#datepicker" ).datepicker(
    {
      minDate: mindt,
      maxDate: maxdt,
      dateFormat: "yy/mm/dd",
      defaultDate: null,
      onSelect: function(dateText, inst) {
        $("#delivery_date").val(dateText);
      },
      beforeShowDay : function(date) {
          var disableDate = $.datepicker.formatDate(dateFormat, date);
          return [( disableDates.indexOf(disableDate) == -1 ), "", ""];
      }
    }
  );

  /* input validation */
  $('.form input[type="button"]').click(function() {
    var isRequired = 0;
    $(this).parent("form").find("input[required],.input_limit input[required], select[required]").each(function(i, form) {
      if(!$(form).val() || $(this).children("option:selected").val() == "") {
        $(form).css('box-shadow','0 0 0 1px #D45A15');
        $("html, body").animate({scrollTop: 0}, 'fast');
        isRequired++;
      } else {
        $(form).removeAttr("style");
      }
    });
    if(isRequired == 0){
      $(this).parent("form").submit();
    }else{
      if(!$('.error_form').length){
        $(this).parent("form").siblings(".errors").append('<p class="error_form">該当箇所を入力してください</p>').show();
      }
    }
  });
  /* zip code */
  $('input[name="address[zip]"]').on('blur',function(){
    var zip  = $(this).val();
    var han = zip.replace(/[Ａ-Ｚａ-ｚ０-９]/g,function(s){return String.fromCharCode(s.charCodeAt(0)-0xFEE0)});
    $(this).val(han);

    if(han.length < 7) {
      $('input[name="address[zip]"]').addClass('error');
      $('input[name="address[zip]"]').prev("label").children(".error_zip").show();
      return;
    } else if(han.length > 7) {
      $('input[name="address[zip]"]').addClass('error');
      $('input[name="address[zip]"]').prev("label").children(".error_zip").show();
      return;
    }

    AjaxZip3.zip2addr(this,'','address[province]','address[city]');

    AjaxZip3.onSuccess = function() {
      $('input[name="address[zip]"]').removeClass('error');
      $('input[name="address[zip]"]').removeClass('require');
      $(".error_zip").hide();
      $('input[name="address[zip]"], .input_limit:not(.form_name) input[required], select[required]').removeAttr("style");
      $(".input_limit input").trigger('load');
      //$('input[name="address[address1]"]').focus();
    };
    AjaxZip3.onFailure = function() {
      $('input[name="address[zip]"]').addClass('error');
      $('input[name="address[zip]"]').prev("label").children(".error_zip").show();
    }
  });
  /* input text count */
  $(".input_limit input").on("", function(){
    var str = $(this).val();
    var name = $(this).attr('name');

    str = str.replace( /[A-Za-z0-9-!"#$%&'()=<>,.?_\[\]{}@^~\\]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) + 65248);
    });

    var beforeStr = new Array('ｧ','ｨ','ｩ','ｪ','ｫ','ｬ','ｭ','ｮ','ｯ','ｰ','ｳﾞ','ｶﾞ','ｷﾞ','ｸﾞ','ｹﾞ','ｺﾞ','ｻﾞ','ｼﾞ','ｽﾞ','ｾﾞ','ｿﾞ','ﾀﾞ','ﾁﾞ','ﾂﾞ','ﾃﾞ','ﾄﾞ','ﾊﾞ','ﾋﾞ','ﾌﾞ','ﾍﾞ','ﾎﾞ','ﾊﾟ','ﾋﾟ','ﾌﾟ','ﾍﾟ','ﾎﾟ','ｱ','ｲ','ｳ','ｴ','ｵ','ｶ','ｷ','ｸ','ｹ','ｺ','ｻ','ｼ','ｽ','ｾ','ｿ','ﾀ','ﾁ','ﾂ','ﾃ','ﾄ','ﾅ','ﾆ','ﾇ','ﾈ','ﾉ','ﾊ','ﾋ','ﾌ','ﾍ','ﾎ','ﾏ','ﾐ','ﾑ','ﾒ','ﾓ','ﾔ','ﾕ','ﾖ','ﾗ','ﾘ','ﾙ','ﾚ','ﾛ','ﾜ','ｦ','ﾝ');
    var afterStr = new Array('ァ','ィ','ゥ','ェ','ォ','ャ','ュ','ョ','ッ','ー','ヴ','ガ','ギ','グ','ゲ','ゴ','ザ','ジ','ズ','ゼ','ゾ','ダ','ヂ','ヅ','デ','ド','バ','ビ','ブ','ベ','ボ','パ','ピ','プ','ペ','ポ','ア','イ','ウ','エ','オ','カ','キ','ク','ケ','コ','サ','シ','ス','セ','ソ','タ','チ','ツ','テ','ト','ナ','ニ','ヌ','ネ','ノ','ハ','ヒ','フ','ヘ','ホ','マ','ミ','ム','メ','モ','ヤ','ユ','ヨ','ラ','リ','ル','レ','ロ','ワ','ヲ','ン');

    for(var i = 0; i < beforeStr.length; i++) {
      str = str.replace(new RegExp(beforeStr[i], 'g'), afterStr[i]);
    }

    $(this).val(str);
    var txtcount = $(this).val().length;
    $(this).parent().prev("label").children(".limit_num").text(txtcount);

    var MAXLENGTH = 32;
    // 建物名と部屋番号のところだけ32文字でチェックする
    if (name == "checkout[shipping_address][address2]") {
      MAXLENGTH = 32;
    }
    if(txtcount >= MAXLENGTH){
      $(this).parent().addClass("error");
      $(this).parent().prev("label").children(".limit_num").addClass("error");
    } else {
      $(this).parent().removeClass("error");
      $(this).parent().prev("label").children(".limit_num").removeClass("error");
    }
  });
  $(".input_limit input").trigger('load');

  console.log('init finish');
}
